/* cSpell:disable */
import { HeaderConfig } from '@tenants/types/tenant';
import { LOCALE_EXP_REALTY_US_PATHS } from 'types/locales';

/**
 * Creates a header configuration for the eXp Realty US tenant.
 *
 * This function generates a standardized header configuration that includes:
 * - Main and authentication button text
 * - Authentication menu items (saved searches, favorites, profile, sign out)
 * - Main navigation menu items
 *
 * @returns A complete header configuration object with all necessary navigation and authentication elements
 */
export function createHeaderConfig(): HeaderConfig {
  const headerConfig: HeaderConfig = {
    mainButtonCopy: LOCALE_EXP_REALTY_US_PATHS.HEADER_BUTTONS_MAIN_BUTTON,
    authButtonCopy: LOCALE_EXP_REALTY_US_PATHS.HEADER_BUTTONS_AUTH_BUTTON,
    hasJoinExpPage: true,
    authMenuItems: [
      {
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_AUTH_MENU_ITEMS_MY_SAVED_SEARCHES,
        link: '/account/saved/searches',
        id: 'my-saved-searches',
      },
      {
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_AUTH_MENU_ITEMS_MY_FAVOURITES,
        link: '/account/saved/favourites',
        id: 'my-favourites',
      },
      {
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_AUTH_MENU_ITEMS_EDIT_PROFILE,
        link: '/account/details',
        id: 'edit-profile',
      },
      {
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_AUTH_MENU_ITEMS_SIGN_OUT,
        id: 'sign-out',
        signOut: true,
      },
    ],
    menuItems: [
      {
        id: 'buy',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_BUY,
        link: '/buy',
      },
      {
        id: 'sell',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_SELL,
        link: '/sell',
      },
      {
        id: 'find-an-agent',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_FIND_AN_AGENT,
        link: '/agents-search',
      },
      {
        id: 'join-exp',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_JOIN_EXP,
        link: 'https://join.exprealty.com',
        newTab: true,
      },
      {
        id: 'agent-login',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_AGENT_LOGIN,
        link: 'https://my.exprealty.com/login',
        newTab: true,
      },
      {
        id: 'about',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_ABOUT,
        link: '/explore-exp',
      },
      {
        id: 'accessibility',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_ACCESSIBILITY,
        link: '/accessibility',
      },
      {
        id: 'sitemap',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_SITEMAP,
        link: '/sitemap',
      },
      {
        id: 'commercial-waitlist',
        label: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_COMMERCIAL_WAITLIST,
        link: '/commercial-waitlist-us',
        mobileOnly: true,
      },
    ],
    buttonLabels: {
      commercialWaitlist: LOCALE_EXP_REALTY_US_PATHS.HEADER_MENU_ITEMS_COMMERCIAL_WAITLIST,
      imReady: LOCALE_EXP_REALTY_US_PATHS.HEADER_BUTTONS_IM_READY,
      contactUs: LOCALE_EXP_REALTY_US_PATHS.HEADER_BUTTONS_CONTACT_US,
      mainButton: LOCALE_EXP_REALTY_US_PATHS.HEADER_BUTTONS_MAIN_BUTTON,
      authButton: LOCALE_EXP_REALTY_US_PATHS.HEADER_BUTTONS_AUTH_BUTTON,
    },
  };

  return headerConfig;
}
